import React from "react";

const InputMessage = ({ errors, inputType, warningMessage }) => {
  const message = warningMessage || errors[inputType]?.message;

  return (
    <span
      data-testid="input-error-message"
      className={`input-hint ${
        message ? "input-hint__error" : ""
      }`}
    >
      {message || "Aperte ENTER para enviar:"}
    </span>
  );
};

export default InputMessage;
